import { useTranslation } from "react-i18next";
import Cropper, { ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";
import { useRef } from "react";
import { Button } from "alm-react-components";

interface CropModalProps {
  selectedFile: File | null;
  onCrop: (croppedCanvas: HTMLCanvasElement) => void;
  onCancel: () => void;
  isVisible: boolean;
}

const ImageCropperModal = ({
  selectedFile,
  onCrop,
  onCancel,
  isVisible,
}: CropModalProps) => {
  const { t } = useTranslation();
  const cropperRef = useRef<ReactCropperElement>(null);

  if (!isVisible || !selectedFile) {
    return null;
  }

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (!cropper) {
      console.error("Cropper instance not available");
      return;
    }

    const canvas = cropper.getCroppedCanvas({
      imageSmoothingEnabled: true,
      imageSmoothingQuality: "high",
    });

    onCrop(canvas);
  };

  const handleRotate = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      cropper.rotate(90);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[#16171C] border border-primary p-6 pt-3 rounded-lg max-w-md w-full">
        <h2 className="text-xl mb-4 font-opensansSemiBold">
          {t("Common.cropImage")}
        </h2>
        <Cropper
          ref={cropperRef}
          src={URL.createObjectURL(selectedFile)}
          style={{ height: 400, width: "100%" }}
          aspectRatio={1}
          guides={true}
          viewMode={1}
          minCropBoxHeight={10}
          minCropBoxWidth={10}
          background={false}
          responsive={true}
          autoCropArea={1}
          checkOrientation={false}
        />
        <div className="flex justify-between gap-3 mt-4">
          <span
            onClick={onCancel}
            className="px-4 pt-[6px] pb-[3px] w-full rounded text-base flex h-auto border justify-center cursor-pointer hover:bg-transparent bg-transparent text-un-none"
          >
            {t("Common.cancel")}
          </span>
          <Button
            onClick={handleRotate}
            className="px-4 py-2 w-full rounded text-base"
          >
            {t("Common.rotate")}
          </Button>
          <Button
            onClick={handleCrop}
            className="px-4 py-2  w-full rounded text-base"
          >
            {t("Common.save")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImageCropperModal;
